import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import authApiService from "../../services/authServices";
import { jwtDecode } from "jwt-decode";
import Modal from "../../utils/modalUtils";

const RegistrationSuccess = () => {
  const [seasonData, setSeasonData] = useState(null);
  const [hasOpenSeason, setHasOpenSeason] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get("username");
  const lastname = queryParams.get("last_name");
  const firstName = queryParams.get("first_name");
  const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
  const cityId = selectedCity?.id;

  const getAuthUserId = () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return null;
      const decodedToken = jwtDecode(token);
      return decodedToken?.userId || null;
    } catch {
      return null;
    }
  };
  // const cityName = selectedCity?.name;

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const effectiveUserId = getAuthUserId();

        if (!cityId || !effectiveUserId) {
          setSeasonData([]);
          setHasOpenSeason(false);
          return;
        }

        const response = await authApiService.post("paymentCheck", {
          userId: String(effectiveUserId),
          cityId: String(cityId),
        });
        const seasons = Array.isArray(response?.data)
          ? response.data
          : (response?.data?.seasons || []);

        if (seasons.length > 0) {
          setSeasonData(seasons);
          setHasOpenSeason(true);
        } else {
          setSeasonData([]);
          setHasOpenSeason(false);
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
        setSeasonData([]);
        setHasOpenSeason(false);
      }
    };

    fetchPaymentData();
  }, [cityId]);

  // Auto-redirect to Registration (League Play) page immediately when seasons are available
  useEffect(() => {
    if (!seasonData || seasonData.length === 0) return;
    navigate("/carter/payment", { state: { seasonData } });
  }, [seasonData, navigate]);

  console.log("first", seasonData);

  return (
    <div className="page-container col-sm-9">
      <div id="feedback-header">
        <div id="header-feedback-text">
          <span className="count-down">
            <img
              src="/images/guest.png"
              alt="congrats"
              class="mr-2 heading_icon"
            />{" "}
            <span class="text_green">Congratulations:</span> {firstName}{" "}
            {lastname}
          </span>
        </div>
      </div>
      <div className="row mt-4 d-flex align-self-stretch">
        <div className="col-lg-12">
          <div className="shadow-sm feedback-grey-box p-5 h-100 msg-body-container">
            <div className="row mb-5">
              <div className="col-sm-6 mb-3">
                You are now a member of Open Play Tennis
              </div>
              <div className="col-sm-6 mb-3">Ball Boys Optional</div>
            </div>
            <div className="row">
              <div className="col-sm-6 mb-3 font-weight-bold">
                {" "}
                Click here to register for League Play
              </div>
              <div className="col-sm-6 mb-3">
                {hasOpenSeason ? (
                  <Link
                    to="/carter/payment"
                    state={{ seasonData }}
                    className="green_btn"
                  >
                    <span>Register</span>
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="green_btn"
                    onClick={() =>
                      Modal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Registration is currently not available",
                        confirmButtonText: "OK",
                      })
                    }
                  >
                    <span>Register</span>
                  </button>
                )}
              </div>
              <div className="col-sm-6 mb-3 font-weight-bold">
                Take me to my Player Profile
              </div>
              <div className="col-sm-6 mb-3">
                <Link
                  to="#"
                  className="green_btn"
                  onClick={() => {
                    const currentUserId = getAuthUserId();
                    window.location.href = currentUserId
                      ? `/carter/profile?userId=${currentUserId}`
                      : "/carter/profile";
                  }}
                >
                  <span>Player Profile</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!hasOpenSeason && (
        <div className="row mt-3 mb-3">
          <div className="col-lg-12">
            <p className="noseasons">
              No seasons are currently open for registration in your city at
              your level. <br />
              You will be notified before the start of the next season
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationSuccess;
